<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="animated fadeIn">
		<div>
			<b-row v-if="!loading && hasData">
				<b-col cols="12">
					<b-alert
						show
						variant="info">
						{{ translate('duplicated_info_notice') }}
					</b-alert>
				</b-col>
				<b-col class="col-12">
					<b-nav tabs>
						<template v-for="(orderData, index) in data">
							<li
								:key="index"
								:class="active === orderData.id ? 'nav-link active': 'text-gray-dark'"
								class="list-group-item btn text-left pointer"
								@click="active = orderData.id">
								{{ translate('order_id') }}: {{ orderData.id }}
								<span
									v-if="orderData.attributes.completed"
									class="badge badge-green">
									{{ translate('info_completed') }}
								</span>
							</li>
						</template>
					</b-nav>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<order-duplicated-info
						v-if="active"
						:order-id="active"
						@orderCompleted="getOrders" />
				</b-col>
			</b-row>
		</div>
		<is-loading
			:loading-label="translate('loading')"
			:no-data-label="translate('data_not_found')"
			:loading="loading"
			:has-data="hasData" />
	</div>
</template>
<script>

import {
	Grids, DuplicatedOrders,
} from '@/translations';
import Order from '@/util/Order';
import WindowSizes from '@/mixins/WindowSizes';
import OrderDuplicatedInfo from '@/views/Orders/components/OrderDuplicatedInfo';

export default {
	name: 'DuplicatedInfo',
	components: { OrderDuplicatedInfo },
	messages: [
		Grids, DuplicatedOrders,
	],
	mixins: [WindowSizes],
	data() {
		return {
			active: '',
			orders: new Order(),
		};
	},
	computed: {
		loading() {
			return !!this.orders.data.loading;
		},
		errors() {
			return this.orders.data.errors;
		},
		data() {
			try {
				const { data } = this.orders.data.response.data;
				return data;
			} catch (error) {
				return [];
			}
		},
		hasData() {
			const response = this.data.length;
			return !!response;
		},
	},
	watch: {
		copied(value) {
			if (value) {
				setTimeout(() => { this.copied = false; }, 4000);
			}
		},
	},
	mounted() {
		this.getOrders();
	},
	methods: {
		getOrders() {
			this.orders.getOrdersWithDuplicatedInfo().then(() => {
				if (Object.keys(this.data).length > 0 && !this.active) {
					this.active = this.data[0].id;
				}
			});
		},
	},
};
</script>
